import fetch from 'isomorphic-unfetch';
import { notification } from 'antd';
import hash from 'hash.js';
import { getEnv, getInterfaceUrl, getSpaceTime, gtag, localStorage, sessionStorage } from '@/utils/index.js';
import * as Sentry from '@sentry/browser'
import { isAntdPro } from './index';
import {
  reportEventToMonitor
} from '@/utils'

const checkStatus = response => {
  const codeMessage = {
    200: '服务器成功返回请求的数据。',
    201: '新建或修改数据成功。',
    202: '一个请求已经进入后台排队（异步任务）。',
    204: '删除数据成功。',
    400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
    401: '用户没有权限（令牌、用户名、密码错误）。',
    403: '用户得到授权，但是访问是被禁止的。',
    404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
    406: '请求的格式不可得。',
    410: '请求的资源被永久删除，且不会再得到的。',
    422: '当创建一个对象时，发生一个验证错误。',
    500: '服务器发生错误，请检查服务器。',
    502: '网关错误。',
    503: '服务不可用，服务器暂时过载或维护。',
    504: '网关超时。',
  };
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  const errortext = codeMessage[response.status] || response.statusText;
  // 本地和测试环境
  if (getEnv() !== 'production') {
    notification.error({
      message: `${response.status}: ${response.url}`,
      description: errortext,
    });
  }


  console.log(response?.url)

  // 网络异常码报警,针对4xx和5xx
  reportEventToMonitor(`网络异常(network_error):code=${response.status};url=${response.url}`);
  const error = new Error(errortext);
  error.name = response.status;
  error.response = response;
  throw error;
};

// 获取不同设备

// fetch超时处理
const TIMEOUT = 100000;
const checkNetworkStatus = () => {
  return navigator.onLine;
};
const timeoutFetch = async (url, options) => {
  if (!checkNetworkStatus()) {
    return Promise.reject(new Error('Network connection is disconnected'));
  }
  let fetchPromise = fetch(url, options);
  let timeoutPromise = new Promise((resolve, reject) => {
    setTimeout(() => reject(new Error(`Time Out: ${url}`)), TIMEOUT);
  });
  return await Promise.race([fetchPromise, timeoutPromise]);
};

/**
 * Requests a URL, returning a promise.
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [option] The options we want to pass to "fetch"
 * @return {object}           An object containing either "data" or "err"
 */
export default function request(url, option) {
 
  const h5OrWeb = localStorage.getItem('isMobileView') === 'WEB' ? 'WEB' : 'H5';

  const options = {
    expirys: isAntdPro(),
    ...option,
  };

  /**
   * Produce fingerprints based on url and parameters
   * Maybe url has the same parameters
   */
  const fingerprint = url + (options.body ? JSON.stringify(options.body) : '');
  const hashcode = hash
    .sha256()
    .update(fingerprint)
    .digest('hex');
  const token = sessionStorage.getItem('token') || '';
  // 获取 referrer, 如果用户手机为safari无痕模式，是无法使用document.referrer获取，可利用head里的meta标签获取
  const referrer = sessionStorage.getItem('llpayReferrer') || document.querySelector('head meta')?.content || '';

  console.log(referrer);

  /**
   * 渠道要求的其他必传参数
   *  "browserColorDepth": "8",
   *  "browserScreenHeight": 1,
   *  "browserScreenWidth": 1,
   *  "browserTZ": 0,
   */
  const browserColorDepth = window.screen.colorDepth;
  const browserScreenHeight = window.screen.height;
  const browserScreenWidth = window.screen.width;
  const browserTZ = 'UTC+' + (0 - new Date().getTimezoneOffset() / 60);

  const otherOptions = {
    browserColorDepth,
    browserScreenHeight,
    browserScreenWidth,
    browserTZ,
  };
  const defaultOptions = {
    credentials: 'include',
  };
  const newOptions = { ...defaultOptions, ...options };
  if (
    newOptions.method === 'POST' ||
    newOptions.method === 'PUT' ||
    newOptions.method === 'DELETE'
  ) {
    if (!(newOptions.body instanceof FormData)) {
      newOptions.headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8',
        ...newOptions.headers,
        Authorization: token,
        referrer,
        ...otherOptions,
      };
      newOptions.body = JSON.stringify(newOptions.body);
    } else {
      // newOptions.body is FormData
      newOptions.headers = {
        Accept: 'application/json',
        ...newOptions.headers,
        Authorization: token,
        referrer,
        ...otherOptions,
      };
    }
  }

  if (newOptions.method === 'GET') {
    newOptions.headers = {
      ...newOptions.headers,
      Authorization: token,
      referrer,
      ...otherOptions,
    };
  }
  const expirys = options.expirys && 60;
  // options.expirys !== false, return the cache,
  if (options.expirys !== false) {
    const cached = sessionStorage.getItem(hashcode);
    const whenCached = sessionStorage.getItem(`${hashcode}:timestamp`);
    if (cached !== null && whenCached !== null) {
      const age = (Date.now() - whenCached) / 1000;
      if (age < expirys) {
        const response = new Response(new Blob([cached]));
        return response.json();
      }
      sessionStorage.removeItem(hashcode);
      sessionStorage.removeItem(`${hashcode}:timestamp`);
    }
  }

  let ContentDisposition;
  return (
    timeoutFetch(url, newOptions)
      .then(checkStatus)
      .then(response => {

        // DELETE and 204 do not return data by default
        // using .json will report an error.
        if (newOptions.method === 'DELETE' || response.status === 204) {
          return response.json();
        }
        if (newOptions.method === 'GET' && newOptions.blob) {
          ContentDisposition = response.headers.get('Content-Disposition');
          return response.blob();
        }

        console.log('监控====1');
        console.log(response)

        return response.json();
      })
      .then(response => {
        if (newOptions.method === 'GET' && newOptions.blob) {
          response = {
            ContentDisposition,
            response,
          };
          return response;
        }
        
        



        return response;
      })
      .catch(e => {
        const ignoreSentryErrors = ['Network connection is disconnected', 'Failed to fetch', 'Time Out']; 
        const notificationErrors = ['Network connection is disconnected'];
        //报警策略
        if(!ignoreSentryErrors.includes(e?.message)) {
          Sentry.captureException(e);
        } 
        //用户页面提示
        if(notificationErrors.includes(e?.message)) {
          notification.error({
            message: 'Network request failed.',
            description: 'Please check your network connection and try again.'
          });
        }
        console.error('请求失败', {
          url,
          error: e.message,
          userAgent: navigator?.userAgent || 'unknown'
        });
        return Promise.reject(e);
      })
  );
}
